import './InternationalHospitalCard.css';

export const InternationalHospitalCard = ({ logo, name, onViewProfile }) => {
  return (
    <div className="ihc-card">
      <div className="ihc-card__logo-wrap">
        <img src={logo} alt={name} className="ihc-card__logo" />
      </div>
      <p className="ihc-card__name">{name}</p>
      <button className="ihc-card__btn" onClick={onViewProfile}>
        View Profile
      </button>
    </div>
  );
};
